// extracted by mini-css-extract-plugin
module.exports = {"content":"QuestionModal_content__2IyAZ","content__title":"QuestionModal_content__title__35dSq"};